export default "__VITE_ASSET__Bnc9xf0O__"